export class User {

    idUser: number;
    name: string;
    email: string;
    phone: string;
    pro: number;
    password: string;
    token: string;
    admin: number;
    idGroup: number;
    groupName: string;

    constructor() {
        this.idUser = 0;
        this.name = '';
        this.email = '';
        this.phone = '';
        this.password = '';
        this.token = '';
        this.pro = 0;
        this.admin = 0;
        this.groupName = '';
    }
}
